/**
 * Instrument API
 * Manage Instrument data
 *
 * The version of the OpenAPI document: 1.1.37
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { AddDocument } from '../model/models';
import { PagingResultDtoDoc } from '../model/models';
import { Problem } from '../model/models';
import { ResultDoc } from '../model/models';
import { SearchDocsDto } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class DocumentResourceService {

    protected basePath = 'https://issuer-ipa-develop.dev.socgen';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * addDocument
     * Upload one document  **Authorization policy:**  Scopes: api.issuer-ipa.v1, api.issuer-ipa.document.add.confc0, api.issuer-ipa.document.add.confc1, api.issuer-ipa.document.add.confc2; Authorities: SGM_ISS_PAY_api.issuer-ipa.document.add.confc0, SGM_ISS_PAY_api.issuer-ipa.document.add.confc1, SGM_ISS_PAY_api.issuer-ipa.document.add.confc2
     * @param confidentialityLevel Confidentiality level to use for saving document
     * @param modelId Model ID to use for saving document
     * @param metadata Metadata from programme, instrument,...
     * @param file File to be saved
     * @param newDocumentName Custom name of file
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addDocument(confidentialityLevel: 'DEFAULT' | 'C0' | 'C1' | 'C2', modelId: string, metadata: string, file: Blob, newDocumentName?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json'}): Observable<AddDocument>;
    public addDocument(confidentialityLevel: 'DEFAULT' | 'C0' | 'C1' | 'C2', modelId: string, metadata: string, file: Blob, newDocumentName?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json'}): Observable<HttpResponse<AddDocument>>;
    public addDocument(confidentialityLevel: 'DEFAULT' | 'C0' | 'C1' | 'C2', modelId: string, metadata: string, file: Blob, newDocumentName?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json'}): Observable<HttpEvent<AddDocument>>;
    public addDocument(confidentialityLevel: 'DEFAULT' | 'C0' | 'C1' | 'C2', modelId: string, metadata: string, file: Blob, newDocumentName?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/problem+json'}): Observable<any> {
        if (confidentialityLevel === null || confidentialityLevel === undefined) {
            throw new Error('Required parameter confidentialityLevel was null or undefined when calling addDocument.');
        }
        if (modelId === null || modelId === undefined) {
            throw new Error('Required parameter modelId was null or undefined when calling addDocument.');
        }
        if (metadata === null || metadata === undefined) {
            throw new Error('Required parameter metadata was null or undefined when calling addDocument.');
        }
        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling addDocument.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (confidentialityLevel !== undefined && confidentialityLevel !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>confidentialityLevel, 'confidentialityLevel');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (sgconnect) required
        credential = this.configuration.lookupCredential('sgconnect');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (newDocumentName !== undefined) {
            formParams = formParams.append('newDocumentName', <any>newDocumentName) as any || formParams;
        }
        if (modelId !== undefined) {
            formParams = formParams.append('modelId', <any>modelId) as any || formParams;
        }
        if (metadata !== undefined) {
            formParams = formParams.append('metadata', <any>metadata) as any || formParams;
        }
        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<AddDocument>(`${this.configuration.basePath}/api/v1/documents`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteDocument
     * Delete a Document  **Authorization policy:**  Scopes: api.issuer-ipa.v1, api.issuer-ipa.document.delete.confc0, api.issuer-ipa.document.delete.confc1, api.issuer-ipa.document.delete.confc2; Authorities: SGM_ISS_PAY_api.issuer-ipa.document.delete.confc0, SGM_ISS_PAY_api.issuer-ipa.document.delete.confc1, SGM_ISS_PAY_api.issuer-ipa.document.delete.confc2
     * @param documentId id of a Document
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteDocument(documentId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json'}): Observable<any>;
    public deleteDocument(documentId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json'}): Observable<HttpResponse<any>>;
    public deleteDocument(documentId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json'}): Observable<HttpEvent<any>>;
    public deleteDocument(documentId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/problem+json'}): Observable<any> {
        if (documentId === null || documentId === undefined) {
            throw new Error('Required parameter documentId was null or undefined when calling deleteDocument.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (sgconnect) required
        credential = this.configuration.lookupCredential('sgconnect');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.delete<any>(`${this.configuration.basePath}/api/v1/documents/${encodeURIComponent(String(documentId))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * search documents by page
     * search documents by page  **Authorization policy:**  Scopes: api.issuer-ipa.v1, api.issuer-ipa.document.get.confc0, api.issuer-ipa.document.get.confc1, api.issuer-ipa.document.get.confc2; Authorities: SGM_ISS_PAY_api.issuer-ipa.document.get.confc0, SGM_ISS_PAY_api.issuer-ipa.document.get.confc1, SGM_ISS_PAY_api.issuer-ipa.document.get.confc2
     * @param searchDocsDto 
     * @param page number of page
     * @param size size of page
     * @param field Name of field to filtering : [confidentialityLevel, creationDate, documentName, documentType] or empty value
     * @param sorted Direction to filtering, use only when field to filtering is valued
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchByPage(searchDocsDto: SearchDocsDto, page?: number, size?: number, field?: string, sorted?: 'ASC' | 'DESC', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json' }): Observable<PagingResultDtoDoc>;
    public searchByPage(searchDocsDto: SearchDocsDto, page?: number, size?: number, field?: string, sorted?: 'ASC' | 'DESC', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json' }): Observable<HttpResponse<PagingResultDtoDoc>>;
    public searchByPage(searchDocsDto: SearchDocsDto, page?: number, size?: number, field?: string, sorted?: 'ASC' | 'DESC', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json' }): Observable<HttpEvent<PagingResultDtoDoc>>;
    public searchByPage(searchDocsDto: SearchDocsDto, page?: number, size?: number, field?: string, sorted?: 'ASC' | 'DESC', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json' }): Observable<any> {
        if (searchDocsDto === null || searchDocsDto === undefined) {
            throw new Error('Required parameter searchDocsDto was null or undefined when calling searchByPage.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (size !== undefined && size !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>size, 'size');
        }
        if (field !== undefined && field !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>field, 'field');
        }
        if (sorted !== undefined && sorted !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>sorted, 'sorted');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (sgconnect) required
        credential = this.configuration.lookupCredential('sgconnect');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/problem+json',
                'application/json',
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<PagingResultDtoDoc>(`${this.configuration.basePath}/api/v1/documents/_search-by-page`,
            searchDocsDto,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchDocuments
     * Search document by query  **Authorization policy:**  Scopes: api.issuer-ipa.v1, api.issuer-ipa.document.get.confc0, api.issuer-ipa.document.get.confc1, api.issuer-ipa.document.get.confc2; Authorities: SGM_ISS_PAY_api.issuer-ipa.document.get.confc0, SGM_ISS_PAY_api.issuer-ipa.document.get.confc1, SGM_ISS_PAY_api.issuer-ipa.document.get.confc2
     * @param searchDocsDto 
     * @param field Name of field to filtering : [confidentialityLevel, creationDate, documentName, documentType] or empty value
     * @param sorted Direction to filtering, use only when field to filtering is valued
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchDocuments(searchDocsDto: SearchDocsDto, field?: string, sorted?: 'ASC' | 'DESC', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json' }): Observable<ResultDoc>;
    public searchDocuments(searchDocsDto: SearchDocsDto, field?: string, sorted?: 'ASC' | 'DESC', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json' }): Observable<HttpResponse<ResultDoc>>;
    public searchDocuments(searchDocsDto: SearchDocsDto, field?: string, sorted?: 'ASC' | 'DESC', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json' }): Observable<HttpEvent<ResultDoc>>;
    public searchDocuments(searchDocsDto: SearchDocsDto, field?: string, sorted?: 'ASC' | 'DESC', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json' }): Observable<any> {
        if (searchDocsDto === null || searchDocsDto === undefined) {
            throw new Error('Required parameter searchDocsDto was null or undefined when calling searchDocuments.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (field !== undefined && field !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>field, 'field');
        }
        if (sorted !== undefined && sorted !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>sorted, 'sorted');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (sgconnect) required
        credential = this.configuration.lookupCredential('sgconnect');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/problem+json',
                'application/json',
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<ResultDoc>(`${this.configuration.basePath}/api/v1/documents/_search`,
            searchDocsDto,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
